import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { useTranslation } from '@lyearn/i18n';
import { Box, LinkButton, Typography } from '@lyearn/ui';
import { useUserContext } from '@/modules/auth/hooks/useUser';
import { UserStatusEnum } from '@/types/schema';

const Header = ({ onResetLinkClick }: { onResetLinkClick: () => void }) => {
  const { t } = useTranslation();
  const { isMobile } = useScreen();
  const user = useUserContext();

  return (
    <Box className="mb-32 ms-4 xs:mb-40 xs:ms-8">
      <Typography variant={isMobile ? 'heading-l' : 'heading-m'}>
        {t('Common:Actions.ResetPassword')}
      </Typography>
      {user.status === UserStatusEnum.EmailNotVerified ? (
        <Typography className="mt-4" color="text-text-secondary" variant="body-short-01">
          {t('Auth:resetPasswordDescriptionUnverifiedEmail')}
        </Typography>
      ) : (
        <Typography className="mt-4" color="text-text-secondary" variant="body-short-01">
          {t('Auth:resetPasswordDescription')}
          <LinkButton onClick={onResetLinkClick}>
            <Typography className="text-link-external hover:text-link-external-hover active:text-link-external-active">
              {t('Auth:resetLink')}
            </Typography>
          </LinkButton>
        </Typography>
      )}
    </Box>
  );
};

export default React.memo(Header);
